var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-notransform",attrs:{"outlined":"","small":"","color":"secondary"},on:{"click":_vm.add}},[_c('span',[_vm._v("Add")]),_c('v-icon',{attrs:{"right":"","small":""}},[_vm._v("mdi-plus")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }